import { getSdk } from "services/datocms/generated";
import { createDatoClient } from "services/datocms";
import { NavigationItem } from "helpers/navigation-items-by-tag";

export type InfoPageNavPosition = "before_collections" | "after_collections";

export interface InfoPageNavItem extends NavigationItem {
  navPosition: InfoPageNavPosition;
}

export async function fetchInfoPageNavItems(): Promise<InfoPageNavItem[]> {
  const { allInfoPages } = await getSdk(createDatoClient()).AllInfoPages();

  return allInfoPages
    .filter((page) => page.showInNav && page.slug)
    .map((page) => ({
      id: page.id,
      title: page.navTitle || page.title || "",
      url: `/info/${page.slug}`,
      navPosition:
        (page.navPosition?.trim() as InfoPageNavPosition) ??
        "after_collections",
    }));
}
